////////////////////////////////////////////////////////////////////////////////
//                                                                             /
//                                                                             /
//  (C) Copyright 2025 Autodesk, Inc. All rights reserved.                     /
//                                                                             /
//                       ****  CONFIDENTIAL MATERIAL  ****                     /
//                                                                             /
//  The information contained herein is confidential, proprietary to           /
//  Autodesk, Inc., and considered a trade secret.  Use of this information    /
//  by anyone other than authorized employees of Autodesk, Inc. is granted     /
//  only under a written nondisclosure agreement, expressly prescribing        /
//  the scope and manner of such use.                                          /
//                                                                             /
////////////////////////////////////////////////////////////////////////////////

import {SettingsSourceState} from "../states/SettingsSourceState";
import {SettingsSourceActions} from "../../Enums";

export function reducer(state: SettingsSourceState, action: {
  type: SettingsSourceActions,
  payload: any
}): SettingsSourceState {
  switch (action.type) {
    case SettingsSourceActions.filterOpen:
      return {...state, FilterOpen: action.payload};
    case SettingsSourceActions.selectedFileTypes:
      return {...state, SelectedFileTypes: action.payload};
  }
}